import React, { useState } from 'react';
import { FaUserCircle } from "react-icons/fa";
import { FaBars, FaTimes } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { GrSecure } from "react-icons/gr";

const Navbar = () => {
    const [isSidebarOpen, setSidebar] = useState(false);

    return (
        <nav className="absolute z-10 px-[15%] pt-[5%] top-0 left-0 w-full flex justify-between items-center p-5 bg-transparent text-white">
            {/* LOGO */}
            {/* <div className="text-xl font-bold">LOGO</div> */}
            <div>
                <img src="logox-removebg-preview.png" alt="" className='w-[150px]'/>
            </div>

            {/* Navigation Links - Hidden on Mobile */}
            <div className="xl:block lg:block hidden">
                <ul className="flex gap-5">
                    <a href="/">
                        <li>Home</li>
                    </a>
                    <a href="/about">
                        <li>About</li>
                    </a>
                    <a href="/contact">
                        <li>Contact</li>
                    </a>
                    <li>FAQ</li>
                    <span>|</span>
                    <div className="flex gap-2">
                        <div className="pt-1">
                            <FaUserCircle />
                        </div>
                        <a href="https://app.portpayinvestment.com/login" target='_blank' rel="noreferrer">
                            <li>Login</li>
                        </a>
                    </div>
                    <div className="trans_bg relative bottom-1">
                      <a href="https://app.portpayinvestment.com/register" target='_blank' rel="noreferrer">
                      <li>Signup</li>
                      </a>
                    </div>
                </ul>
            </div>

            {/* Sidebar Icon - Visible on Mobile */}
            <div className="text-2xl cursor-pointer md:block xl:hidden lg:hidden">
                <button onClick={() => setSidebar(true)} className="text-2xl">
                    <FaBars />
                </button>
            </div>

            {/* Popup Overlay */}
            {isSidebarOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    {/* Popup Box */}
                    <div className="bg-gradient-to-br animate-scale-up  from-white to-gray-200 p-6 mx-5 md:p-8 rounded-lg shadow-2xl w-full md:w-[50%] max-w-xl relative">
                        {/* Close Button */}
                        <button
                            onClick={() => setSidebar(false)}
                            className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 text-xl"
                        >
                            <FaTimes />
                        </button>

                        {/* Navigation Links */}
                        <ul className="space-y-4 text-black">
                            <li className="flex items-center gap-3 hover:text-blue-600">
                                <IoIosArrowForward />
                                <a href="/">
                                    <span>Home</span>
                                </a>
                            </li>
                            <li className="flex items-center gap-3 hover:text-blue-600">
                                <IoIosArrowForward />
                                <a href="/about">
                                <span>About</span>
                                </a>
                            </li>
                            <li className="flex items-center gap-3 hover:text-blue-600">
                                <IoIosArrowForward />
                                <a href="/contact">
                                <span>Contact</span>
                                </a>
                            </li>
                            <li className="flex items-center gap-3 hover:text-blue-600">
                                <IoIosArrowForward />
                                <span>FAQ</span>
                            </li>
                            <hr className="border-gray-300" />
                            <li className="flex justify-between items-center gap-3">
                                <a href="https://app.portpayinvestment.com/login" target='_blank' rel="noreferrer">
                                <button className="bg-[black] text-white py-2 px-4 rounded-lg">
                                    <div className='flex gap-2'>
                                        <div className='pt-1'>
                                            <GrSecure />
                                        </div>
                                        Login
                                    </div>
                                </button>
                                </a>
                                <a href="https://app.portpayinvestment.com/register" target='_blank' rel="noreferrer">
                                <button className="bg-[#071f04] text-white py-2 px-4 rounded-lg">
                                    <div className='flex gap-2'>
                                        <div className='pt-1'>
                                            <FaUserCircle />
                                        </div>
                                        Signup
                                    </div>

                                </button>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            )}


        </nav>
    );
};

export default Navbar;
